/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import cn from 'classnames';
import makeStyles from '@mui/styles/makeStyles';
import { PersonIcon } from 'components/elements/Icons';
import Styles from './styles';
import useVideoRoomParticipant from './useVideoRoomParticipant';
import AudioTrack from './AudioTrack';
import VideoTrack from './VideoTrack';

const useStyles = makeStyles(Styles);

function Participant({ participant, muted, isDominant, nameLabel, isLocalUser, isScreenShared }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  const { videoTrack, audioTrack, mainVideoTrackEnabled } = useVideoRoomParticipant({ participant, muted, isLocalUser });
  const [isActiveName, setIsActiveName] = useState(false);

  return (
    <div
      onMouseOver={() => setIsActiveName(true)}
      onMouseLeave={() => setIsActiveName(false)}
      onClick={() => {
        setIsActiveName(true);
        setTimeout(() => {
          setIsActiveName(false);
        }, 3000);
      }}
      className={cn(classes.videoRoomParticipant, { [classes.dominantGridParticipantVideoItem]: isDominant })}
    >
      {!mainVideoTrackEnabled ? (
        <div className={classes.disabledCamParticipantNameWrap}>
          <PersonIcon classes={classes.personIcon} />
          <Typography className={classes.disabledCamParticipantName} variant="body2" component="span" noWrap>
            {nameLabel}
          </Typography>
          <Typography className={classes.camParticipantNameLocal} variant="body2" component="span">
            {isLocalUser && <> {`(${t('you')})`}</>}
          </Typography>
        </div>
      ) : (
        <>
          <div className={cn(classes.participantName, { [classes.smallParticipantName]: isScreenShared }, { [classes.hoveredParticipantName]: isActiveName })}>
            <Typography className={classes.camParticipantName} variant="body2" component="span" noWrap>
              {nameLabel}
            </Typography>
            <Typography className={classes.camParticipantNameLocal} variant="body2" component="span">
              {isLocalUser && <> {`(${t('you')})`}</>}
            </Typography>
          </div>
          <VideoTrack track={videoTrack} isLocal={isLocalUser} />
        </>
      )}
      {!muted && !isLocalUser && audioTrack && <AudioTrack track={audioTrack} />}
    </div>
  );
}

Participant.propTypes = {
  participant: PropTypes.objectOf(PropTypes.any).isRequired,
  muted: PropTypes.bool,
  isDominant: PropTypes.bool,
  nameLabel: PropTypes.string.isRequired,
  isLocalUser: PropTypes.bool,
  isScreenShared: PropTypes.bool,
};

Participant.defaultProps = {
  isDominant: false,
  isLocalUser: false,
  isScreenShared: false,
  muted: false,
};

export default Participant;
